import Carousel from "../../components/categories/carousel";
import PageTitle from "../../components/ui_components/pageTitle";
import { useTranslation } from "next-i18next";
import { useQuery } from "@apollo/client";
import { categoriesGql } from "../../gql/queries";
import { CategoryEntityResponseCollection } from "../../gql-types";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const Categories = () => {
  const { loading, data } = useQuery<{
    categories?: CategoryEntityResponseCollection;
  }>(categoriesGql);
  const { t } = useTranslation("categories_carousel");
  return (
    <div className="bg-backgroundGrey relative">
      <div id="categories" className="p-4 flex flex-col items-center scroll-mt-16 pt-0">
        <PageTitle title={t("categories_titles")} underlineYellow />
        <Carousel data={!loading && data?.categories?.data} loading={loading} />
      </div>
      <div className="bg-blue w-36 h-2.5 absolute right-0 rtl:left-0 rtl:right-auto"></div>
    </div>
  );
};
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "layout",
        "categories",
        "categories_carousel",
        "signup_promotion",
      ])),
    },
  };
}
export default Categories;
